import IconSvg from "../../../../SharedComponents/IconSvg";
import { Button, Carousel } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import React, { useEffect, useState } from "react";
import Image from "react-bootstrap/Image";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LandingPageCarousel = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [isLg, setIsLg] = useState(window.innerWidth >= 992);

  useEffect(() => {
    const handleResize = () => {
      setIsLg(window.innerWidth >= 992);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Row className={"justify-content-center mx-lg-0"}>
      <Col xs={12} xl={10} style={{ backgroundColor: "#274C77", borderRadius: "30px", minHeight: "500px" }}>
        <Carousel
          nextIcon={<IconSvg height={15} width={8} icon={"carouselArrowMirrored"} />}
          prevIcon={<IconSvg height={15} width={8} icon={"carouselArrow"} />}
          className={"landing-page-carousel"}
        >
          <Carousel.Item className={"py-4 px-0"}>
            <Row className={"m-0 h-100 justify-content-between"}>
              <Col className={"align-content-center ps-2 ps-lg-4 pt-5 pb-3 mt-5 mb-3"}>
                <Row className={"EB-Garamond text-color-white text-56 mx-0 lh-1"}>Cus-Pro</Row>
                <Row className={"EB-Garamond text-color-white text-56 mx-0 lh-1"}>
                  {t("landing.carousel.slide1.title")}
                </Row>

                <Row className={" text-color-white text-18 mx-0 mt-5"}>{t("landing.carousel.slide1.description")}</Row>

                <Row className={" text-color-white text-18 mx-0 mt-5"}>
                  <Col className={"px-0"}>
                    <Button className={"button white rounded-pill px-2"} onClick={() => navigate("/contact")}>
                      <Row>
                        <Col className={"ps-3 pe-0 align-content-center "}>{t("landing.carousel.demoButton")}</Col>
                        <Col xs={"auto"}>
                          <div
                            className={"rounded-circle flex-center"}
                            style={{ backgroundColor: "#274c77", width: 36, height: 36 }}
                          >
                            <IconSvg height={15} width={8} icon={"carouselArrowMirrored"} fill={"#fff"} />
                          </div>
                        </Col>
                      </Row>
                    </Button>
                  </Col>
                </Row>
              </Col>
              <Col xs={12} lg={"auto"}>
                <div
                  style={{
                    overflow: "hidden", // ensures image corners are clipped
                    borderRadius: "28px", // adjust the smoothness here
                    width: isLg ? "470px" : "100%",
                  }}
                >
                  <Image
                    src={"/LandingPageImages/accountantManStaringAtUser.webp"}
                    alt="manAndWomanWithLaptop"
                    style={{
                      display: "block", // remove bottom whitespace
                      width: "100%",
                      height: "auto",
                    }}
                  />
                </div>
              </Col>
            </Row>
          </Carousel.Item>
          <Carousel.Item className={"py-4 px-0"}>
            <Row className={"m-0 h-100 justify-content-between"}>
              <Col className={"align-content-center ps-2 ps-lg-4 pt-5 pb-3 mt-5 mb-3"}>
                <Row className={"EB-Garamond text-color-white text-56 mx-0 lh-1"}>Cus-Pro</Row>
                <Row className={"EB-Garamond text-color-white text-56 mx-0 lh-1"}>
                  {t("landing.carousel.slide2.title")}
                </Row>

                <Row className={" text-color-white text-18 mx-0 mt-5"}>{t("landing.carousel.slide2.description")}</Row>

                <Row className={" text-color-white text-18 mx-0 mt-5"}>
                  <Col className={"px-0"}>
                    <Button className={"button white rounded-pill px-2"} onClick={() => navigate("/contact")}>
                      <Row>
                        <Col className={"ps-3 pe-0 align-content-center "}>{t("landing.carousel.demoButton")}</Col>
                        <Col xs={"auto"}>
                          <div
                            className={"rounded-circle flex-center"}
                            style={{ backgroundColor: "#274c77", width: 36, height: 36 }}
                          >
                            <IconSvg height={15} width={8} icon={"carouselArrowMirrored"} fill={"#fff"} />
                          </div>
                        </Col>
                      </Row>
                    </Button>
                  </Col>
                </Row>
              </Col>
              <Col xs={12} lg={"auto"}>
                <div
                  style={{
                    overflow: "hidden", // ensures image corners are clipped
                    borderRadius: "28px", // adjust the smoothness here
                    width: isLg ? "470px" : "100%",
                  }}
                >
                  <Image
                    src={"/LandingPageImages/teamStaringAtUser.webp"}
                    alt="manAndWomanWithLaptop"
                    style={{
                      display: "block", // remove bottom whitespace
                      width: "100%",
                      height: "auto",
                    }}
                  />
                </div>
              </Col>
            </Row>
          </Carousel.Item>
          <Carousel.Item className={"py-4 px-0"}>
            <Row className={"m-0 h-100 justify-content-between"}>
              <Col className={"align-content-center ps-2 ps-lg-4 pt-5 pb-3 mt-5 mb-3"}>
                <Row className={"EB-Garamond text-color-white text-56 mx-0 lh-1"}>Cus-Pro</Row>
                <Row className={"EB-Garamond text-color-white text-56 mx-0 lh-1"}>
                  {t("landing.carousel.slide3.title")}
                </Row>

                <Row className={" text-color-white text-18 mx-0 mt-5"}>{t("landing.carousel.slide3.description")}</Row>

                <Row className={" text-color-white text-18 mx-0 mt-5"}>
                  <Col className={"px-0"}>
                    <Button className={"button white rounded-pill px-2"} onClick={() => navigate("/contact")}>
                      <Row>
                        <Col className={"ps-3 pe-0 align-content-center "}>{t("landing.carousel.demoButton")}</Col>
                        <Col xs={"auto"}>
                          <div
                            className={"rounded-circle flex-center"}
                            style={{ backgroundColor: "#274c77", width: 36, height: 36 }}
                          >
                            <IconSvg height={15} width={8} icon={"carouselArrowMirrored"} fill={"#fff"} />
                          </div>
                        </Col>
                      </Row>
                    </Button>
                  </Col>
                </Row>
              </Col>
              <Col xs={12} lg={"auto"}>
                <div
                  style={{
                    overflow: "hidden", // ensures image corners are clipped
                    borderRadius: "28px", // adjust the smoothness here
                    width: isLg ? "470px" : "100%",
                  }}
                >
                  <Image
                    src={"/LandingPageImages/manAndWomanWithLaptop.webp"}
                    alt="manAndWomanWithLaptop"
                    style={{
                      display: "block", // remove bottom whitespace
                      width: "100%",
                      height: "auto",
                    }}
                  />
                </div>
              </Col>
            </Row>
          </Carousel.Item>
        </Carousel>
      </Col>
    </Row>
  );
};
export default LandingPageCarousel;
